import { heroImage, statItems } from "@/mocks/content";

const quickTags = ["眼泪女王", "黑暗荣耀", "请回答1988", "苦尽柑来遇见你", "悬疑", "治愈"];

interface HeroProps {
  query: string;
  onQueryChange: (value: string) => void;
}

export default function Hero({ query, onQueryChange }: HeroProps) {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const target = document.getElementById("genres");
    if (target) target.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="relative flex min-h-[640px] w-full items-center overflow-hidden lg:min-h-[720px]">
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt=""
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/60 to-foreground-950/80"></div>

      <div className="relative z-10 mx-auto w-full max-w-5xl px-4 py-28 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 font-label text-sm text-background-100 backdrop-blur">
          <i className="ri-fire-line text-accent-400" aria-hidden="true"></i>
          本周 120+ 部韩剧正在更新
        </span>

        <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
          韩剧TV · 最新韩剧与高分剧单一站追更
        </h1>
        <p className="mx-auto mt-5 max-w-2xl font-body text-sm leading-relaxed text-background-100 md:text-base">
          聚合正在更新的最新韩剧与口碑高分剧单，覆盖热播剧、完结经典与小众好剧。
          按热度、评分、题材分类整理，从剧荒到追更，一站式解决。
        </p>

        <form onSubmit={handleSubmit} className="mx-auto mt-8 flex max-w-xl flex-col gap-2 sm:flex-row">
          <div className="relative flex-1">
            <i
              className="ri-search-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-foreground-500"
              aria-hidden="true"
            ></i>
            <input
              type="search"
              name="drama-search"
              value={query}
              onChange={(e) => onQueryChange(e.target.value)}
              placeholder="搜索剧名、演员或题材，如：眼泪女王"
              aria-label="搜索剧名、演员或题材"
              className="w-full rounded-md border border-background-50/25 bg-background-50/95 py-3 pl-11 pr-4 font-body text-sm text-foreground-950 outline-none transition placeholder:text-foreground-500 focus:border-primary-400 focus:ring-2 focus:ring-primary-400/40"
            />
          </div>
          <button
            type="submit"
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            开始找剧
          </button>
        </form>

        <div className="mt-5 flex flex-wrap items-center justify-center gap-2">
          <span className="font-label text-xs text-background-200">热门搜索：</span>
          {quickTags.map((tag) => (
            <button
              key={tag}
              type="button"
              onClick={() => onQueryChange(tag)}
              className="rounded-full border border-background-50/30 px-3 py-1 font-label text-xs text-background-100 transition-colors hover:border-accent-400 hover:text-accent-400"
            >
              {tag}
            </button>
          ))}
        </div>

        <dl className="mx-auto mt-12 grid max-w-3xl grid-cols-2 gap-4 md:grid-cols-4">
          {statItems.map((item) => (
            <div key={item.label} className="rounded-lg bg-background-50/10 px-4 py-3 backdrop-blur">
              <dt className="font-label text-xs text-background-200">{item.label}</dt>
              <dd className="mt-1 font-heading text-xl font-bold text-background-50 md:text-2xl">
                {item.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}